module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-stone-path.dd726e95.png";